// extracted by mini-css-extract-plugin
export default {"sectionList":"ypckAvVYdZwK9It3mJejz"};